<script>
export default {
    props: {
        marketPlaces: {
            default: null,
        },
    },
    data() {
        return {
            showLoading: false,
            form: {
                checked:[],
                percentage:null
            },
            formatedForm:[]
        };
    },
    methods: {
        submit(){
            this.$emit("handleMarketUpdate", this.form);
        },
    },
};
</script>

<template>
    <div class="modal fade" tabindex="-1" id="edit_market" rel="">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">

                    <!--begin::Close-->
                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                        aria-label="Close">
                        <span class="svg-icon svg-icon-2x"></span>
                    </div>
                    <!--end::Close-->
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-4">
                            <h2>
                                {{ $t('bulkPriceUpdate') }}
                            </h2>
                        </div>
                        <div class="col-md-8">
                            <div class="d-flex justify-content-end"><!--begin::Button--><a
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                    data-kt-contacts-type="cancel" class="btn btn-light me-3">{{ $t('cancel') }}</a><!--end::Button--><!--begin::Button--><button @click="submit" type="submit"
                                    data-kt-contacts-type="submit" class="btn btn-primary btn-app"
                                    data-text="إضافة تصنيف"><span class="indicator-label">{{ $t('save') }}</span><span
                                        class="indicator-progress">{{ $t('pleaseWait') }} <span
                                            class="spinner-border spinner-border-sm align-middle ms-2"></span></span></button><!--end::Button-->
                            </div>
                        </div>
                    </div>
                    <div class="row" >
                        <div class="col-md-12">
                            <div class="card mb-10" >
                                <div class="card-body">
                                    <div class="row">
                                    <div class="col-md-4" v-for="marketPlace,index in marketPlaces" :key="index">
                                        <input type="checkbox" v-model="form.checked" :value="marketPlace.id" />
                                        <br/>
                                        <img :src="marketPlace.marketplace.logo_url" />
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="input-group mb-3">

                                <input type="text" class="form-control" v-model="form.percentage">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style >
#edit_market .modal-dialog {
    max-width: 80%;
}
</style>
